<template>

  <span class="vz-lazy-image" :style="style" v-when-visible="loadImage"></span>

</template>

<script>
import WhenVisibleDirective from '../../directives/v-when-visible';

export default {

  name: 'VzLazyImage',
  emits: ['load-start', 'load-complete', 'load-error'],
  directives: {
    whenVisible: WhenVisibleDirective
  },

  props: {
    src: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    imgSrc: '',
    imgObj: null
  }),

  computed: {

    style: function () {
      return { backgroundImage: this.imgSrc ? 'url(' + this.src + ')' : 'none' };
    }

  },

  watch: {

    src: function () {
      if(this.imgObj) {
        this.unlistenEvents();
        this.loadImage();
      }
    }

  },

  methods: {

    unlistenEvents: function () {
      this.imgObj.removeEventListener('load', this.showImage);
      this.imgObj.removeEventListener('error', this.emitError);
    },

    emitError: function () {
      this.unlistenEvents();
      this.$emit('load-error');
    },

    showImage: function () {
      this.imgSrc = this.src;
      this.unlistenEvents();
      this.$emit('load-complete');
    },

    loadImage: function () {
      if(this.src) {
        this.$emit('load-start');
        this.imgObj = new Image();
        this.imgObj.addEventListener('load', this.showImage);
        this.imgObj.addEventListener('error', this.emitError);
        this.imgObj.src = this.src;
      }
    }

  }

}
</script>

<style>

</style>
